import styled from "@emotion/styled";
import { Box } from "@mui/material";

export const ImagemContainer = styled(Box)`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 1rem;
    width: 100%;
`